import { default as MuiList } from '@mui/material/List';

/**
 * Lists display vertical groupings of continuous text-only related content.
 *
 * Demos:
 *
 * - [UnifyList](https://unify.workiva.org/components/list?tab=code)
 *
 * API:
 *
 * - [UnifyList API](https://unify.workiva.org/components/list?tab=props)
 */
// IMPORTANT TO KEEP THIS ALIAS `UnifyList`, since we want to use that name and not `List` when generating the Dart bindings.
export const UnifyList = MuiList;
export {
  // IMPORTANT TO KEEP THIS ALIAS `UnifyListProps`, for consistency with `UnifyList`
  type ListProps as UnifyListProps,
  listClasses as unifyListClasses,
} from '@mui/material/List';
